import { Divider, Typography } from '@mui/material';

import * as S from './styles';

export interface CreditsSummaryProps {
  subtotal: number;
  remaining: number;
  totalDue: number;
}

const CreditsSummary: React.FC<CreditsSummaryProps> = ({
  subtotal,
  remaining,
  totalDue,
}) => (
  <S.CreditsSummary>
    <S.CreditSummaryRow>
      <Typography variant="h2">Subtotal</Typography>

      <Typography variant="h2">${subtotal}</Typography>
    </S.CreditSummaryRow>

    <S.CreditSummaryRow>
      <S.CreditApplied variant="h4" fontWeight={700} letterSpacing="normal">
        Credit applied (automatic)
      </S.CreditApplied>

      <Typography variant="h2">-${remaining}</Typography>
    </S.CreditSummaryRow>

    <Divider />

    <S.CreditSummaryRow>
      <Typography variant="h2">Total due</Typography>

      <Typography variant="h2">${totalDue}</Typography>
    </S.CreditSummaryRow>
  </S.CreditsSummary>
);

export default CreditsSummary;
